/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const languageDataSchema = z.object({
	id: z.number(),
	code: z.string(),
	name: z.string(),
})

export type LanguageDataSchema = z.infer<typeof languageDataSchema>
